import { HTTP } from '@/utils/http-common'

export default {
    discover (name) {
        return HTTP.get('/singerio/tap/' + name + '/discover/')
    },
    configFields (name, stream, fields) {
        return HTTP.post('/singerio/tap/' + name + '/config/' + stream + '/fields/', fields).catch(function (error) {
            console.log(error)
        })
    },
    execute(id, headers) {
      return new Promise((resolve, reject) => {
        return HTTP.get('/singerio/tap/' + id + '/execute/', headers).then(res => {
          return resolve(res)
        }).catch((err) => {
          return reject(err)
        })
      })
    },
    getlogs(id, header) {
      return HTTP.get('/singerio/tap/' + id + '/logs/')
    },
}
